import { h, Component, render } from "preact";
import Required from "./Required";
import Modal from "../Modal";
import RichTextDisplay from "../RichTextDisplay";
import { css } from "emotion";

const wrapper = css({
  width: "80vw"
});

class TermsAndConditionsField extends Component {
  constructor() {
    super();
    this.state = {
      showModal: false
    };
  }
  toggleOpen = () => {
    this.setState({ showModal: !this.state.showModal });
  };
  render({
    input,
    rename,
    label,
    required,
    inputType,
    options,
    settings,
    meta: { touched, error, warning }
  }) {
    const fieldName = rename || "Terms & Conditions";
    let contents = "";

    let invalidObj = {};
    if (required) {
      invalidObj = {
        "aria-invalid": error && touched ? "true" : "false"
      };
    }
    if (inputType === "text") {
      contents = settings ? <RichTextDisplay html={settings.text} /> : null;
    } else {
      contents = settings ? (
        <div className={wrapper}>
          <embed
            src={`https://process.filestackapi.com/${settings.pdf}`}
            width="100%"
            height="480"
            type="application/pdf"
          />
        </div>
      ) : null;
    }
    return (
      <div class={touched && error ? "form-group has-error" : "form-group"}>
        <label for={input.name} class="form-checkbox">
          <input
            type="checkbox"
            aria-required={required ? "true" : "false"}
            id={input.name}
            {...input}
            checked={input.value}
            aria-label={`checkbox field:${input.name}`}
            {...invalidObj}
          />
          <i class="form-icon" style={"1px solid #8d949e"} /> I have read and
          agree to (
          {inputType === "url" && settings && settings.link ? (
            <a href={settings.link} target="_blank">
              {fieldName}
            </a>
          ) : (
            <a href="#" onClick={this.toggleOpen}>
              {fieldName}
            </a>
          )}
          )
          <Required required={required} />
        </label>
        <Modal
          showModal={this.state.showModal}
          closeHandler={this.toggleOpen}
          title={label}
          contents={contents}
        />
        {touched && error && <p class="form-input-hint">{error}</p>}
      </div>
    );
  }
}
export default TermsAndConditionsField;



// WEBPACK FOOTER //
// ./components/fields/TermsAndConditionsField.js